export const getAssistiveText = ({ active, step, href }) => {
    if (active) {
        return `Huidige stap: `;
    }
    if (href === undefined) {
        return `Stap ${step}: `;
    }
    return `Ga naar stap ${step}: `;
};
